$(function () {
  $('.counter').counter({
    formatter: function (value) {
      return value.toFixed(0)
    },
  })

  $('#headerMenus').menus({
    button: '#menuOpenBtn',
    dropdown: '.drop-menu',
    menuItem: '.header-menu_item',
    menuList: '.header-menu_list',
    activeClass: 'active',
    accordion: true,
    timeout: 300,
    width: 1025,
  }) // 菜单展开
})
